(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptLanguageDeleteController',RptLanguageDeleteController);

    RptLanguageDeleteController.$inject = ['$uibModalInstance', 'entity', 'RptLanguage'];

    function RptLanguageDeleteController($uibModalInstance, entity, RptLanguage) {
        var vm = this;

        vm.rptLanguage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RptLanguage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
